import React from 'react';
import { FileText } from 'lucide-react';
import { TERMS_OF_USE_CONTENT } from '../../content/termsOfUse';
import { LegalDocumentPage } from './LegalDocumentPage';

export function TermsOfUsePage() {
  const content = TERMS_OF_USE_CONTENT;

  return (
    <LegalDocumentPage
      canonicalPath="/terms"
      content={content}
      footerCompanyBlock={{
        title: '17. Company Information',
        companyName: content.companyName,
        companyDetails: content.companyDetails,
        email: content.email,
      }}
      icon={FileText}
      keywords="terms of use, vevi monster terms, ai dubbing terms, captions terms, audio translation terms"
    />
  );
}
